<template>
  <div class="flex bg-gray-50 font-lexend dark:bg-gray-900">
    <div class="flex-auto w-full overflow-auto h-screen transition-colors" id="body-scroll" data-scrollbar="true" tabindex="-1" style="overflow: hidden; outline: none;">
      <div class="scroll-content">
        <div class="container lg:max-w-7xl mx-auto text-center mt-40">
          <div class="space-y-8">
            <h1 class="text-9xl dark:text-white text-gray-800 font-bold">404</h1>
            <h2 class="text-4xl dark:text-white text-gray-800">This Page Not Found</h2>
            <p class="dark:text-gray-500 text-gray-800">Sorry, the page you are looking for was not found!</p>
            <button 
              class="bg-primary rounded text-white py-3 px-5"
              @click="$router.push('/')"
            >
              Return To Dashboard
            </button>
          </div>
        </div>
      </div>
      <div class="scrollbar-track scrollbar-track-x" style="display: none;">
        <div class="scrollbar-thumb scrollbar-thumb-x" style="width: 1287px; transform: translate3d(0px, 0px, 0px);"></div>
      </div>
      <div class="scrollbar-track scrollbar-track-y" style="display: none;">
        <div class="scrollbar-thumb scrollbar-thumb-y" style="height: 937px; transform: translate3d(0px, 0px, 0px);"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    document.title = '404 - Page Not Found';
  },
};
</script>

<style>

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  text-align: center;
}

.text-9xl {
  font-size: 9rem;
}

.text-4xl {
  font-size: 4rem;
}

.text-gray-800 {
  color: #4b5563;
}

.text-white {
  color: #fff;
}

.text-red-500 {
  color: #f56565;
}

.bg-gray-50 {
  background-color: #f9fafb;
}

.dark:bg-gray-900 {
  background-color: #1a202c;
}

.space-y-8 > *:not(:last-child) {
  margin-bottom: 2rem;
}

.rounded {
  border-radius: 0.25rem;
}

.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.bg-primary {
  background-color: rgb(79, 70, 229);
  border: none;
  cursor: pointer;
}

.scroll-content {
  transform: translate3d(0px, 0px, 0px);
}

.scrollbar-track {
  display: none;
}

.scrollbar-thumb {
  width: 1287px;
  transform: translate3d(0px, 0px, 0px);
  /* Дополнительные стили для скроллбара */
}
</style>